export default __webpack_public_path__ + "static/media/icon-close-circle.5098eead.svg";